/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".divider[_ngcontent-%COMP%]{border:.5px solid #b8b8b8;margin:.5rem .6rem}.divider[_ngcontent-%COMP%]:first-child{margin-top:0}  .clr-vertical-nav .nav-trigger+.nav-content{border:none;padding-top:0}.version[_ngcontent-%COMP%]{margin-left:1rem;font-size:10pt}.branding[_ngcontent-%COMP%]{padding-left:.5rem}.logo[_ngcontent-%COMP%]{height:68%;padding-right:1rem}.title[_ngcontent-%COMP%]{color:#fff}.clr-vertical-nav#sidebar[_ngcontent-%COMP%]   .nav-link.active[_ngcontent-%COMP%]{background-color:var(--success-color)}"];
export { styles as styles };

